import { z } from "zod";
/** Расценка в ответе API */
export const RateSchema = z.object({
    id: z.number(),
    rateNumber: z.string(),
    workName: z.string(),
    unit: z.string().nullable(),
    price: z.number().int(),
    changeDate: z.string().nullable(),
});
/** Детальная расценка */
export const RateDetailSchema = RateSchema.extend({
    fileId: z.number(),
    createdAt: z.string(),
});
/** Список расценок с пагинацией */
export const RateListResponseSchema = z.object({
    rates: z.array(RateSchema),
    total: z.number(),
    page: z.number(),
    pageSize: z.number(),
});
/** Параметры запроса расценок */
export const RateListQuerySchema = z.object({
    fileId: z.coerce.number().int(),
    search: z.string().optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
});
//# sourceMappingURL=rates.js.map